import { Injectable } from '@angular/core';
import { NavigationDropdown, NavigationItem, NavigationLink, NavigationSubheading } from '../interfaces/navigation-item.interface';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  private _items: NavigationItem[] = [];
  private _itemsSubject = new BehaviorSubject<NavigationItem[]>([]);
  items$ = this._itemsSubject.asObservable();

  // Getter/setter for backwards compatibility
  get items(): NavigationItem[] {
    return this._items;
  }

  set items(value: NavigationItem[]) {
    this._items = value;
    this._itemsSubject.next(value);
  }

  private _openChangeSubject = new Subject<NavigationDropdown>();
  openChange$ = this._openChangeSubject.asObservable();

  constructor() {}

  triggerOpenChange(item: NavigationDropdown) {
    this._openChangeSubject.next(item);
  }

  isLink(item: NavigationItem): item is NavigationLink {
    return item.type === 'link';
  }

  isDropdown(item: NavigationItem): item is NavigationDropdown {
    return item.type === 'dropdown';
  }

  isSubheading(item: NavigationItem): item is NavigationSubheading {
    return item.type === 'subheading';
  }
}
